window.addEventListener("load", function () {
    var days = document.querySelectorAll("#diemdanh .day");
    days.forEach(function (day) {
        day.addEventListener("click", function () {
            var wasActive = day.classList.contains("tooltip-active");
            days.forEach(function (d) { d.classList.remove("tooltip-active"); });
            if (!wasActive) day.classList.add("tooltip-active");
        });
    });
    document.addEventListener("click", function (e) {
        if (!e.target.closest("#diemdanh .day")) {
            days.forEach(function (d) { d.classList.remove("tooltip-active"); });
        }
    });
});
